























import { defineComponent, computed, PropType } from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { ICustomerIconImage, ICustomerIconProps } from './types/CustomerIcon';

export default defineComponent({
  name: 'CustomerIcon',
  components: {
    FCImage,
  },
  props: {
    image: {
      type: Object as PropType<ICustomerIconImage>,
      required: true,
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: ICustomerIconProps) {
    return {
      hasValidImage: computed(() => props.image && props.image?.filename !== ''),
    };
  },
});
